import type { ContextMenuPassThroughOptions } from 'primereact/contextmenu';

/** Убирает недопустимый для menuitem атрибут уровня, добавляемый PrimeReact 10 */
export const CONTEXT_MENU_PT: ContextMenuPassThroughOptions = {
    menuitem: { 'aria-level': undefined },
};
